// @flow
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../../../reducers/appstate'
import SubscriptionName from './SubscriptionName'
import type { PropsType, DispatchPropsType } from './SubscriptionName'
import { addNameAction } from '../../../actions/subscriptionActions'

const mapStateToProps = (state: AppStateType, ownProps: { isPromo?: boolean }): any => {
  return ({
    isPromo: ownProps.isPromo,
    isNameError: !!state.subscriptionPurchase && !!state.subscriptionPurchase.error && !state.subscriptionPurchase.name
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    updateName: (name: string): void => dispatch(addNameAction(name))
  }: DispatchPropsType)
}

export default connect<DispatchPropsType, {||}, _, _, _, _>(mapStateToProps, mapDispatchToProps)(SubscriptionName)
